/* eslint-disable  */
import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import moment from 'moment';
import { Button, Chip, Tooltip } from '@mui/material';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import BackdropLoader from '../../Components/Loaders/BackdropLoader';
import { ListTable } from '../../Components/ListTable';
import { modalActions } from '../../Actions';
import { notificationServices } from '../../Services';
import { urls } from '../../Constants';
import { classes, filtersInfoChip, getActionColumn, handleExportData } from '../../Helpers';
import styles from './ListShift.module.scss';
import shiftServices from '../../Services/shift.service';
import ShiftTableModal from '../../Components/Modals/ShiftTableModal/ShiftTableModal';
import drawerActions from '@/Actions/drawer.actions';
import { Filter, RefreshCcw } from 'lucide-react';
import GlobalSearch from '@/Components/globalSearch/search';
import { useAuth } from '@/Components/Auth/Login/auth';

const TABLE_COLUMNS = [
	{
		title: 'ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Shift Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Start Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'End Date',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMNS = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
];

const ADDITIONAL_COLUMNS = [
	{
		title: 'Actions',
		config: {
			type: 'DATA',
		},
	},
];

const COL_MAP = {
	ID: 'id',
	Store: 'store.title',
	'Shift Name': 'shiftName',
	'Start Date': 'startDate',
	'End Date': 'endDate',
	Cancel: 'id',
};

const ListShiftManagment = ({ toggleModal, toggleAlert, toggleFiltersDrawer }) => {
	const [shiftData, setShiftData] = useState([]);
	const [isLoading, setLoading] = useState(false);
	const [filters, setFilters] = useState({});
	const [search, setSearch] = useState('');
	const [isFetching, setIsFetching] = useState(false);
	const history = useHistory();
	const { userConfig } = useAuth();
	const { level } = userConfig?.userDetails || {};

	const fetchShifts = async () => {
		setFilters({});
		try {
			setLoading(true);
			const response = await shiftServices.listShift();
			if (response?.statusCode === 200) {
				setShiftData(response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handleDelete = async (shiftId) => {
		try {
			setLoading(true);
			const response = await shiftServices.deleteShift({
				data: {
					id: shiftId,
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'Shift deleted successfully',
				});
				const remShifts = shiftData.filter((shift) => {
					return shift.id !== shiftId;
				});

				setShiftData(remShifts);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const SPECIAL_ITEMS = {
		Actions: (shiftId) => {
			const shiftAction = shiftData.find((shift) => {
				return shift.id === shiftId;
			});
			return (
				<div className={styles.actions}>
					<Button
						onClick={() => {
							history.push(
								`${urls.EXTENSION}${urls.SHIFT_CREATE}?isEdit=True&id=${shiftId}`
							);
						}}
						variant='outlined'
						color='primary'
						fullWidth
					>
						Edit
					</Button>
					<div
						style={{
							width: '125px',
						}}
					>
						<Button
							variant='outlined'
							color='error'
							onClick={() => {
								toggleAlert(true, {
									heading: 'Delete Shift?',
									handleConfirm: () => {
										handleDelete(shiftId);
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you want to Delete Shift ${shiftAction?.shiftName}?`,
								});
							}}
							fullWidth
						>
							Delete
						</Button>
					</div>
				</div>
			);
		},
	};

	const handleFind = async (data) => {
		setFilters(data);
		setIsFetching(true);
		try {
			setLoading(true);
			const filter = {
				processTypes: data?.processTypes?.id,
				store: data?.store?.id,
			};
			if (data?.dateOnly?.active) {
				filter.dateOnly = moment(data?.dateOnly?.date).format('YYYY-MM-DD');
			}
			const response = await shiftServices.listShift({
				data: filter,
			});
			if (response?.statusCode === 200) {
				setShiftData(response?.data);
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
			setIsFetching(false);
		}
		return data;
	};

	const handleAddClick = () => {
		history.push(`${urls.EXTENSION}${urls.SHIFT_CREATE}`);
	};

	const fetchShiftInfo = async (shiftId) => {
		try {
			setLoading(true);
			const response = await shiftServices.getShift({
				data: {
					id: shiftId,
				},
			});
			if (response?.statusCode === 200) {
				toggleModal(true, response?.data);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setLoading(false);
		}
		return {};
	};

	const handleViewClick = (shift) => {
		fetchShiftInfo(shift?.id);
	};

	const filtersInfo = {
		header : {
			store : false,
			process: false,
			date: false,
		},
		filteredStore : {
			text: 'Store',
			show: true,
		},
		processType : {
			text: 'Process Type',
			show: true,
		},
		dateOnly : {
			text: 'Shifts for',
			show: true,
		},
	};

	const exportInfo = {
		showExportBtn : true,
	};

	const generateData = () => {
		if (!search) return shiftData;
		return shiftData?.filter((ele) => {
			return ele?.shiftName?.toLowerCase()?.includes(search?.toLowerCase());
		});
	}

	useEffect(() => {
		if (!isFetching) {
			fetchShifts();
		}
	}, []);
	
	return (
		<div className={styles.root}>
			<ShiftTableModal />
			<BackdropLoader isLoading={isLoading} showProgress />
			<ImagesFinder
				onSubmit={handleFind}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex flex-col gap-3 p-2 w-full'>
				<div className='flex justify-between items-center'>
					<span className='font-bold text-[16px]'>Shift Managment</span>
					{level !== 1 && (
						<Button
							onClick={handleAddClick}
							className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
						>
							+ Add Shift
						</Button>
					)}
				</div>
				<div className='flex justify-center gap-3 items-center'>
						<GlobalSearch 
							placeholder='Search by Shift Name'
							searchDropDown={false}
							setSearchValue={setSearch}
							placeholderText='Search by Shift Name'
						/>
					<Tooltip title='Refresh Shifts'>
						<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
							fetchShifts();
						}} />
					</Tooltip>
					<Button
						onClick={() => {
							toggleFiltersDrawer(true, {
								exportFrontend : true,
								handleExportFrontend : () => handleExportData(shiftData, COL_MAP,'Shift Managment', filters),
							});
						}}
						className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='flex items-center gap-2 text-nowrap capitalize'>Filter & Export</span>
						<Filter className='size-5 ' />
					</Button>
				</div>
			</div>
				{filtersInfoChip(filtersInfo, filters)}
				<ListTable
					columns={TABLE_COLUMNS}
					colMap={COL_MAP}
					actions={getActionColumn(BASE_COLUMNS, ADDITIONAL_COLUMNS, level)}
					special={SPECIAL_ITEMS}
					handleViewClick={handleViewClick}
					data={generateData()?.map((ele) => {
						const status = ele?.status?.split(' ').join('_');
						return {
							...ele,
							rowStyles: classes(
								styles.row,
								styles?.[status]
							),
						};
					})}
					allowExport={false}
					showBtnContainer={false}
				/>
			</div>
	);
};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleShiftTableModal,
	toggleAlert: modalActions.toggleAlert,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};
export default connect(mapStateToProps, mapDispatchToProps)(ListShiftManagment);
